import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-group custom-shadow mb-4 rounded-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalStudents = _resolveComponent("TotalStudents")!
  const _component_TotalTeachers = _resolveComponent("TotalTeachers")!
  const _component_AttendanceToday = _resolveComponent("AttendanceToday")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TotalStudents),
    _createVNode(_component_TotalTeachers),
    _createVNode(_component_AttendanceToday)
  ]))
}